module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/utah-b180f7f9a7d4113db8c77352964337ee.jpg";